import React, { lazy, useCallback } from "react";
import { ConfigProvider } from "antd";
import { useThemeLayout } from 'datastake-daf/dist/hooks';
import { ResizeProvider } from "datastake-daf/dist/context";
import PUBLIC from "./publicRoutes";
import Lazy from "../components/Lazy";
import PRIVATE from "./privateRoutes";
import { AuthenticatedRoutes } from "./Routes";
import { FormsProvider } from "../context/Forms";
import { SocketProvider } from "../context/Socket";
import { SelectProvider } from "../context/Select";
import { LinkingProvider } from "../context/Linking";
import { GeneralProvider } from "../context/General";
import { ProjectSourcesProvider } from "../context/ProjectSources";
import { DafTheme } from "datastake-daf/dist/components";
import { useApp } from "../helpers/user";
import { StoreProvider } from "../screens/DataStore/context";
import { InformationChannelProvider } from "../screens/InformationChannels/context";
import { FindInformationProvider } from "../screens/FindInformation/store";
import { tifTheme } from "../constants/tifTheme";
import { mmtTheme } from "../constants/mmtTheme";
import { tazamaTheme } from "../constants/tazamaTheme";
import { ApplicationsProvider } from "../context/Applications";

const ROUTES = [
  ...PUBLIC,
  {
    path: "/app",
    key: "APP",
    component: <AuthenticatedRoutes />,
    routes: PRIVATE
  }
];

const AppRoutes = lazy(() => import("./Routes"));

export default function Router() {
  const app = useApp();

  const callback = useCallback(() => {
    switch (app) {
      case 'tif':
        return tifTheme;
      case 'tazama':
        return tazamaTheme;
      default:
        return mmtTheme;
    }
  }, [app]);

  const { theme } = useThemeLayout({ callback });

  return (
    <ConfigProvider theme={{ token: theme }}>
      <DafTheme theme={theme}>
        <GeneralProvider theme={theme}>
          <SocketProvider>
            <ResizeProvider>
              <SelectProvider>
                <FormsProvider>
                  <ApplicationsProvider>
                    <LinkingProvider>
                      <ProjectSourcesProvider>
                        <StoreProvider>
                          <FindInformationProvider>
                            <InformationChannelProvider>
                              <Lazy>
                                <AppRoutes routes={ROUTES} />
                              </Lazy>
                            </InformationChannelProvider>
                          </FindInformationProvider>
                        </StoreProvider>
                      </ProjectSourcesProvider>
                    </LinkingProvider>
                  </ApplicationsProvider>
                </FormsProvider>
              </SelectProvider>
            </ResizeProvider>
          </SocketProvider>
        </GeneralProvider>
      </DafTheme>
    </ConfigProvider>
  );
}
